import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './actions';
import { VehicleDetails } from '../../../components/vehicle';
import IncludedExtras from '../components/accordions/IncludedExtras';
import ExteriorColour from './components/ExteriorColour';
import Extras from './components/Extras';
import Terms from './components/Terms';
import { isEmpty } from 'lodash';

import * as routes from '../../../routes/const';

import { NitroLoading, NitroHeading, NitroNavBar, NitroDivider, NitroPanel } from 'nitro-components';
import { ColumnContainer, ColumnSmall, ColumnLarge } from '../../../components/layouts/Columns';
import Header from '../../../components/layouts/Header';

class QuoteOptions extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      estimatedCost: 450
    };

    this.setEstimatedCost = this.setEstimatedCost.bind(this);
    this.selectColour = this.selectColour.bind(this);
    this.aToggle = this.aToggle.bind(this);
  }

  componentWillMount() {
    const { updateStep, fetchOptions } = this.props.actions;
    const { selectedVehicle } = this.props;

    if (!isEmpty(selectedVehicle)) {
      updateStep(1);
      fetchOptions(selectedVehicle.QuoteTemplateId, selectedVehicle.VariantId);
    } else {
      this.context.router.push(routes.CQ_CREATE_VEHICLE);
    }
  }

  setEstimatedCost(event, isInputChecked, price, code, description) {
    const { selectExtra, deSelectExtra } = this.props.actions;
    let estimatedCost = 0;

    if (isInputChecked) {
      estimatedCost = this.state.estimatedCost + price * 0.5;
      selectExtra(code, description);
    } else {
      estimatedCost = this.state.estimatedCost - price * 0.5;
      deSelectExtra(code);
    }
    this.setState({
      estimatedCost: estimatedCost
    });
  }

  selectColour() {
    const { selectColour } = this.props.actions;

    this.props.actions.selectColour;
  }

  aToggle() {
    this.classList.toggle('active');
    this.nextElementSibling.classList.toggle('show');
  }

  render() {
    const { fetchingOptions, selectedVehicle, options, selectedExtras } = this.props;

    if (isEmpty(selectedVehicle) || fetchingOptions) return <NitroLoading screen />;

    return (
      <section>

        <Header margin="32px 0" lineHeight={32}>

          <NitroNavBar
            actionOnHeading
            inline
            float
            noPadding
            lineHeight={26}
            label="Back to vehicle selection"
            action={() => this.context.router.push(routes.CQ_CREATE_VEHICLE)}
          />

          <NitroHeading label="Extras &amp; Colour" align="center" size="1" />
        </Header>

        <ColumnContainer>
          <ColumnSmall>
            <NitroPanel>
              <VehicleDetails disablePanelClick {...selectedVehicle} />
              <NitroDivider />
              <IncludedExtras options={options} active={Boolean(options && options.length)} />
            </NitroPanel>
          </ColumnSmall>

          <ColumnLarge>
            <NitroPanel>
              <ExteriorColour exteriorColour={selectedVehicle.ExteriorColour} selectedColour={this.props.selectedColour} selectColour={this.props.actions.selectColour} />
            </NitroPanel>
            <NitroPanel>
              <Extras
                options={options}
                selectedExtras={selectedExtras}
                setEstimatedCost={this.setEstimatedCost}
                aToggle={this.aToggle}
              />
            </NitroPanel>
          </ColumnLarge>
        </ColumnContainer>

        <Terms
          vehicle={selectedVehicle}
          term={this.props.Term}
          distance={this.props.Distance}
          actionHandler={() => this.context.router.push(routes.CQ_CREATE_LEASE)}
        />

      </section>
    );
  }
}

QuoteOptions.propTypes = {
  options: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired,
  fetchingOptions: PropTypes.bool.isRequired,
  Term: PropTypes.string,
  Distance: PropTypes.string,
  selectedExtras: PropTypes.array,
  selectedColour: PropTypes.object,
  selectedVehicle: PropTypes.object
};

QuoteOptions.contextTypes = {
  router: PropTypes.object
};

const mapStateToProps = state => {
  const { create } = state.corporateQuote;

  return {
    options: create.options,
    fetchingOptions: create.fetchingOptions,
    exteriorColour: create.options.ExteriorColour,
    selectedVehicle: create.selectedVehicle,
    selectedExtras: create.selectedExtras,
    selectedColour: create.selectedColour,
    Term: create.selectedTerms ? create.selectedTerms.Term : null,
    Distance: create.selectedTerms ? create.selectedTerms.Distance : null,
    selectColour: create.selectColour
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(QuoteOptions);



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/QuoteOptions.js